import React, {useState, useEffect, useContext} from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {ContextApp} from '../context/ContextApp'
import Spinner from './Spinner'
import footerBanner from '../assets/banner/footerBanner.jpg'

export default () => {
  const contextApp = useContext(ContextApp)
  const {
    productsFreeDelivery,
    productsByCategory,
    addProductToCarShoppingById,
    productsBySearch,
    setCategoryShowClose,
    reloadProductsByCategory,
    resetRealoadProductsByCategory,
    categoryNameFromMenu,
    contador,
    getProductsDiscountv2,
  } = contextApp

  const productsFreeDelivery_ = productsFreeDelivery.filter(
    category =>
      category.provider_id == 767 ||
      category.provider_id == 759 ||
      category.provider_id == 745 ||
      category.provider_id == 743 ||
      category.provider_id == 727 ||
      category.provider_id == 2,
  )

  let val = 1000
  val = val + contador.correlativo
  console.log('bandera de contador')
  console.log(contador.correlativo)
  console.log(val)

  console.log(productsFreeDelivery_)
  useEffect(() => {
    setCategoryShowClose()
    resetState()
  }, [productsByCategory])

  function resetState() {
    setTimeout(() => {
      resetRealoadProductsByCategory()
    }, 8000)
  }

  return (
    <div id="content" class="site-content" tabindex="-1">
      {productsFreeDelivery_.length == 0 && reloadProductsByCategory == true ? (
        <Spinner />
      ) : (
        <div class="container">
          <nav class="woocommerce-breadcrumb">
            <Link to={'/'}>Home</Link>
            <span class="delimiter"></span>
          </nav>

          <div id="primary" class="content-area">
            <main id="main" class="site-main">
              <header class="page-header">
                {/*<h1 class="page-title"> { productsByCategory[0]?.category?.name }</h1>*/}
                {/*<h1 class="page-title"> { productsByCategory.cat.name}</h1>*/}
                <a href="#">
                  <img src={footerBanner} class="img-responsive" alt="" />
                </a>
                <br />
                <p class="woocommerce-result-count">Resultados de búsqueda</p>
                {/* <p class="woocommerce-result-count">Muestra {productsBySearch.length} &ndash; Resultados</p> */}
              </header>

              {/* <div class="shop-control-bar">
                        <ul class="shop-view-switcher nav nav-tabs" role="tablist">
                            <li class="nav-item"><a class="nav-link active" data-toggle="tab" title="Grid View" href="#grid"><i class="fa fa-th"></i></a></li>
                            <li class="nav-item"><a class="nav-link " data-toggle="tab" title="Grid Extended View" href="#grid-extended"><i class="fa fa-align-justify"></i></a></li>
                            <li class="nav-item"><a class="nav-link " data-toggle="tab" title="List View" href="#list-view"><i class="fa fa-list"></i></a></li>
                            <li class="nav-item"><a class="nav-link " data-toggle="tab" title="List View Small" href="#list-view-small"><i class="fa fa-th-list"></i></a></li>
                        </ul>
                        <form class="woocommerce-ordering" method="get">
                            <select name="orderby" class="orderby">
                                <option value="menu_order" selected='selected'>Default sorting</option>
                                <option value="popularity" >Sort by popularity</option>
                                <option value="rating" >Sort by average rating</option>
                                <option value="date" >Sort by newness</option>
                                <option value="price" >Sort by price: low to high</option>
                                <option value="price-desc" >Sort by price: high to low</option>
                            </select>
                        </form>
                        <form class="form-electro-wc-ppp"><select name="ppp" onchange="this.form.submit()" class="electro-wc-wppp-select c-select"><option value="15" selected='selected'>Show 15</option><option value="-1" >Show All</option></select></form>
                        <nav class="electro-advanced-pagination">
                            <form method="post" class="form-adv-pagination"><input id="goto-page" size="2" min="1" max="2" step="1" type="number" class="form-control" value="1" /></form> of 2<a class="next page-numbers" href="#">&rarr;</a>
                        </nav>
                    </div> */}

              <div>
                <div class="tab-content">
                  <div
                    role="tabpanel"
                    class="tab-pane active"
                    id="grid"
                    aria-expanded="true"
                  >
                    {productsFreeDelivery_.length === 0 ? (
                      <div
                        style={{
                          backgroundColor: '#f2f2f2',
                          borderRadius: '.5rem',
                          width: '90%',
                          margin: '4rem auto',
                          padding: '2rem',
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            color: 'rgba(0,0,0,0.7)',
                            fontSize: '1.3rem',
                            textTransform: 'uppercase',
                          }}
                        >
                          No se encontraron productos para esta categoría
                        </h1>
                      </div>
                    ) : (
                      <ul class="products columns-3">
                        {productsFreeDelivery_.map((product, index) => {
                          let classNames = [
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                            'product first',
                            'product',
                            'product last',
                          ]

                          return (
                            <li key={index} class={classNames[index]}>
                              <div class="product-outer">
                                <div class="product-inner">
                                  <span class="loop-product-categories">
                                    <Link
                                      to={`/products/provider/${product.batches[0].provider.id}`}
                                      className="link-to-category"
                                    >
                                      {product.batches[0].provider.name}
                                    </Link>
                                  </span>
                                  <Link
                                    to={`/product_detail/${product.batches[0].product_id}`}
                                  >
                                    <h3>{product.name}</h3>
                                    <div class="product-thumbnail">
                                      {product.batches[0]?.regular_price !=
                                      product.batches[0]?.unit_price ? (
                                        product.campaing?.active == 1 ? (
                                          product.campaing
                                            ?.campaign_feature_id == 3 ? (
                                            product.campaing?.isdelivery ==
                                            0 ? (
                                              <span class="onsale">
                                                <span class="percentage">
                                                  {(
                                                    ((product.batches[0]
                                                      ?.regular_price -
                                                      (
                                                        product.batches[0]
                                                          .regular_price -
                                                        product.batches[0]
                                                          .regular_price *
                                                          (product.campaing
                                                            ?.discount /
                                                            100)
                                                      ).toFixed(2)) /
                                                      product.batches[0]
                                                        ?.regular_price) *
                                                    100
                                                  ).toFixed(2)}{' '}
                                                  % Ahorro
                                                </span>
                                              </span>
                                            ) : (
                                              <span class="onsale">
                                                <span class="percentage">
                                                  {(
                                                    ((product.batches[0]
                                                      ?.regular_price -
                                                      product.batches[0]
                                                        ?.unit_price) /
                                                      product.batches[0]
                                                        ?.regular_price) *
                                                    100
                                                  ).toFixed(2)}{' '}
                                                  % Ahorro
                                                </span>
                                              </span>
                                            )
                                          ) : (
                                            <span class="onsale">
                                              <span class="percentage">
                                                {(
                                                  ((product.batches[0]
                                                    ?.regular_price -
                                                    product.batches[0]
                                                      ?.unit_price) /
                                                    product.batches[0]
                                                      ?.regular_price) *
                                                  100
                                                ).toFixed(2)}{' '}
                                                % Ahorro
                                              </span>
                                            </span>
                                          )
                                        ) : (
                                          <span class="onsale">
                                            <span class="percentage">
                                              {(
                                                ((product.batches[0]
                                                  ?.regular_price -
                                                  product.batches[0]
                                                    ?.unit_price) /
                                                  product.batches[0]
                                                    ?.regular_price) *
                                                100
                                              ).toFixed(2)}{' '}
                                              % Ahorro
                                            </span>
                                          </span>
                                        )
                                      ) : (
                                        ''
                                      )}

                                      <img src={product.image_url} />
                                    </div>
                                  </Link>

                                  <div class="price-add-to-cart">
                                    <span class="price">
                                      <span class="electro-price">
                                        {product.campaing?.active == 1 ? (
                                          product.campaing
                                            ?.campaign_feature_id == 3 ? (
                                            product.campaing?.isdelivery ==
                                            0 ? (
                                              <ins>
                                                <span
                                                  className="amount"
                                                  style={{
                                                    color: 'red',
                                                    margin: '5px',
                                                  }}
                                                >
                                                  {' '}
                                                  {`$${(
                                                    product.batches[0]
                                                      .regular_price -
                                                    product.batches[0]
                                                      .regular_price *
                                                      (product.campaing
                                                        ?.discount /
                                                        100)
                                                  ).toFixed(2)}`}
                                                </span>
                                              </ins>
                                            ) : product.batches[0]
                                                ?.regular_price !=
                                              product.batches[0]?.unit_price ? (
                                              <ins>
                                                <span
                                                  className="amount"
                                                  style={{
                                                    color: 'red',
                                                    margin: '5px',
                                                  }}
                                                >
                                                  {' '}
                                                  {`$${product?.batches[0]?.unit_price}`}
                                                </span>
                                              </ins>
                                            ) : (
                                              <ins>
                                                <span
                                                  className="amount"
                                                  style={{color: 'black'}}
                                                >
                                                  {' '}
                                                  {`$${product?.batches[0]?.unit_price}`}
                                                </span>
                                              </ins>
                                            )
                                          ) : product.batches[0]
                                              ?.regular_price !=
                                            product.batches[0]?.unit_price ? (
                                            <ins>
                                              <span
                                                className="amount"
                                                style={{
                                                  color: 'red',
                                                  margin: '5px',
                                                }}
                                              >
                                                {' '}
                                                {`$${product?.batches[0]?.unit_price}`}
                                              </span>
                                            </ins>
                                          ) : (
                                            <ins>
                                              <span
                                                className="amount"
                                                style={{color: 'black'}}
                                              >
                                                {' '}
                                                {`$${product?.batches[0]?.unit_price}`}
                                              </span>
                                            </ins>
                                          )
                                        ) : product.batches[0]?.regular_price !=
                                          product.batches[0]?.unit_price ? (
                                          <ins>
                                            <span
                                              className="amount"
                                              style={{
                                                color: 'red',
                                                margin: '5px',
                                              }}
                                            >
                                              {' '}
                                              {`$${product?.batches[0]?.unit_price}`}
                                            </span>
                                          </ins>
                                        ) : (
                                          <ins>
                                            <span
                                              className="amount"
                                              style={{color: 'black'}}
                                            >
                                              {' '}
                                              {`$${product?.batches[0]?.unit_price}`}
                                            </span>
                                          </ins>
                                        )}

                                        <del>
                                          <span className="amount">
                                            {product.batches[0]
                                              ?.regular_price !=
                                            product.batches[0]?.unit_price
                                              ? '$' +
                                                product.batches[0]
                                                  ?.regular_price
                                              : ''}
                                          </span>
                                        </del>
                                      </span>
                                    </span>
                                    <a
                                      onClick={() =>
                                        addProductToCarShoppingById(
                                          product.batches[0].product_id,
                                          productsByCategory,
                                        )
                                      }
                                      rel="nofollow"
                                      class="button add_to_cart_button"
                                    >
                                      Agregar al carrito
                                    </a>
                                  </div>

                                  {/* <div class="hover-area">
                                                            <div class="action-buttons">
                                                                <a href="#" rel="nofollow" class="add_to_wishlist">Wishlist</a>
                                                                <a href="#" class="add-to-compare-link">Compare</a>
                                                            </div>
                                                        </div> */}
                                </div>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    )}

                    <center>
                      <a
                        onClick={() => {
                          getProductsDiscountv2(val)
                        }}
                        class="btn btn-primary"
                      >
                        <font color="white">Ver mas productos</font>
                      </a>
                    </center>
                  </div>
                </div>
              </div>
              {/* <div class="shop-control-bar-bottom">
                        <form class="form-electro-wc-ppp">
                            <select class="electro-wc-wppp-select c-select" onchange="this.form.submit()" name="ppp"><option selected="selected" value="15">Show 15</option><option value="-1">Show All</option></select>
                        </form>
                        <p class="woocommerce-result-count">Muestra 1&ndash;15 of 20 Resultados</p>
                        <nav class="woocommerce-pagination">
                            <ul class="page-numbers">
                                <li><span class="page-numbers current">1</span></li>
                                <li><a href="#" class="page-numbers">2</a></li>
                                <li><a href="#" class="next page-numbers">→</a></li>
                            </ul>
                        </nav>
                    </div> */}
            </main>
          </div>
        </div>
      )}
    </div>
  )
}
